import React from 'react';

export const getOnlyNumbers = s => {
  return `${s.replace(/\D/g, '')}`;
};

export const formatAsPhoneNumber = s => {
  return getOnlyNumbers(s).replace(/(\d{1,2})(\d{1})?(\d{1,3})?(\d{1,4})?/, function (match, p1, p2, p3, p4) {
    return `${p1 ? `(${p1}` : ''}${p2 ? `${p2})` : ''}${p3 ? ` ${p3}` : ''}${p4 ? `-${p4}` : ''}`;
  });
};

export const getPhoneFormat = phoneNumber => {
  const phoneParts = phoneNumber.split('x');

  return `${getOnlyNumbers(phoneParts[0]).length === 10 ? formatAsPhoneNumber(phoneParts[0]) : phoneParts[0].trim()}${
    phoneParts[1] ? ` x ${phoneParts[1].trim()}` : ''
    }`;
};

export const highlightMatch = (text, match) => {
  if (!match) return text;

  const stop = text.toLowerCase().indexOf(match.toLowerCase());

  if (stop === -1) return text;

  const bold = text.slice(stop, stop + match.length);
  const nonBold = text.slice(0, stop);
  const rest = text.slice(stop + match.length, text.length);

  return (
    <span>
      {nonBold}
      <strong className="cps-color-primary">{bold}</strong>
      {rest}
    </span>
  );
};
